import { render, staticRenderFns } from "./InfoView.vue?vue&type=template&id=2809c15f&scoped=true"
import script from "./InfoView.vue?vue&type=script&lang=ts"
export * from "./InfoView.vue?vue&type=script&lang=ts"
import style0 from "./InfoView.vue?vue&type=style&index=0&id=2809c15f&prod&lang=scss"
import style1 from "./InfoView.vue?vue&type=style&index=1&id=2809c15f&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2809c15f",
  null
  
)

export default component.exports